module.exports = __webpack_public_path__ + "media/images/common/ico-lottery-b-9658ed61fa59d18accaff7b5381b20b0.svg";